module.exports = __webpack_public_path__ + "assets/pubmatic.ab451b34.svg";